<template>
  <div :style="{ height, width }" id="EchartsAnimate" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data:function () {
      return {
          echartsData:{
            "size":21,
            "list":[
              {"dysl":"70","mc":"肉制品","dm":"01","sysl":"89"},
              {"dysl":"75","mc":"乳制品","dm":"02","sysl":"107"},
              {"dysl":"40","mc":"速冻食品","dm":"03","sysl":"61"},
              {"dysl":"70","mc":"水产加工","dm":"04","sysl":"90"},
              {"dysl":"43","mc":"面米食品","dm":"05","sysl":"71"},
              {"dysl":"56","mc":"菜品","dm":"06","sysl":"100"},

            ]
          }
      }
  },
  mounted(){
          this.loadEchartsAnimate()
  },
  methods:{
      chartsRelativeSize(percent, derection) {
          var windowW = this.$refs.docement.offsetWidth;
          var windowH = this.$refs.docement.offsetHeight
          var r = 0;
          if ('h' === derection) {
              r = percent * windowH / 100;
          } else {
              r = percent * windowW / 100;
          }
          return r;
      },
      loadEchartsAnimate(){
          var that = this
          var echarts = require('echarts');
          var myCharts = echarts.init(document.getElementById('EchartsAnimate'));
          var option = {
              color:['#407FFF','#00FFBA'],
              tooltip : {
                  trigger: 'axis',
                  textStyle:{
                      color:'#000',
                      fontSize: '12px'
                  },
                  formatter: function (params) {
                      var arr = [];
                      params.forEach(function (item) {
                          var N=item.seriesName;
                          var V = '';
                          if(item.value>100000000){//亿
                              V += (item.value/100000000).toFixed(1) + '亿';
                          }else if( item.value>10000){//万
                              V += (item.value/10000).toFixed(1) + '万';
                          }else{
                              V += item.value;
                          }
                          var a = {name:N,value:V};
                          arr.push(a);
                      });
                      var num = '';
                      arr.forEach(function (item) {
                          num += item.name+":"+item.value+"<br/>";
                      });
                      return params[0].name +"<br>"+ num;
                  }
              },
              grid: {
                  left: '25px',
                  right: '25px',
                  bottom: '9px',
                  top:'70px',
                  containLabel: true
              },
              legend: {
                  orient: 'horizontal',
                  top:'20px',
                  left: '0',
                  itemWidth:10,
                  itemHeight:10,
                  textStyle:{
                      color:'#fff',
                      fontSize: '12px',
                       padding: [5, 0, 0, 0]
                  },
                  data:['下单量','访问量'],
                  z:10001
                  
              },
              xAxis: [
                  {
                      type: 'category',
                      axisLine: {
                          lineStyle: {
                              type: 'solid',
                              color: '#093027',//左边线的颜色
                              width: '1'//坐标线的宽度
                          }
                      },
                      axisLabel: {
                          textStyle: {
                              color: '#fff',//坐标值得具体的颜色,
                              fontSize: '12px'
                          },
                          interval:0
                      },
                      axisTick:false,
                      data: []
                  }
              ],
              yAxis: [
                  {
                      type: 'value',
                      axisLine: {
                        lineStyle: {
                            type: 'solid',
                            color: '#2E3950',//左边线的颜色
                            width: '1'//坐标线的宽度
                        }
                      },
                      axisLabel: {
                        textStyle: {
                            color: '#e6e6e6',//坐标值得具体的颜色,
                            fontSize:'12px'
                        }
                      },
                      axisTick:false,
                      splitLine: {  //坐标轴在grid区域中的分隔线（网格中的横线）
                        show: false,
                        lineStyle: {
                            color: ['#2E3950'],
                            width: 1,
                            type: 'solid',
                        }
                      },
                      splitArea: {//坐标轴在grid区域中的分隔区域（间隔显示网格区域）
                        interval: 1, //显示间隔的规律
                        show: false,
                        areaStyle: {//分隔区域的样式
                            color: ['rgba(255,255,255,0.03)', 'rgba(255,255,255,0)']
                        }
                      }
                  }
              ],
              series : [
                  {
                    name:'下单量',
                    type:'bar',
                    barGap:0,
                    barWidth:10,
                    data:[],
                    itemStyle: {
                        normal: {
                            //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                            barBorderRadius:[5, 5, 5, 5],
                            color:new echarts.graphic.LinearGradient( 0,1,0,0,[
                                { offset: 0, color: '#0371EA' },
                                { offset: 1, color: '#0BCCF8' }
                                ],
                            )}
                    },
                  },{
                    name:'访问量',
                    type:'bar',
                    barGap:0,
                    barWidth:10,
                    data:[],
                    itemStyle: {
                        normal: {
                            //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                            barBorderRadius:[5, 5, 5, 5],
                            color:new echarts.graphic.LinearGradient( 0,1,0,0,[
                                { offset: 0, color: '#072843' },
                                { offset: 1, color: '#00FFC3' }
                                ],
                            )}
                        
                    }
                  }
              ]
          };
          for(var i=0;i<this.echartsData.list.length && i<5;i++){
              option.xAxis[0].data.push( that.echartsData.list[i].mc);
              option.series[0].data.push( that.echartsData.list[i].sysl);
              option.series[1].data.push( that.echartsData.list[i].dysl);
          }
          myCharts.setOption(option);

          if(window.hbfxInterval){
              clearInterval(window.hbfxInterval);
          }
          window.hbfxIndex = 0;
          window.hbfxInterval = setInterval(function () {
              option.xAxis[0].data.shift();
              option.xAxis[0].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].mc);

              option.series[0].data.shift();
              option.series[0].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].sysl);

              option.series[1].data.shift();
              option.series[1].data.push( that.echartsData.list[window.hbfxIndex% that.echartsData.list.length].dysl);

              myCharts.setOption(option);
              window.hbfxIndex ++;
          },2000)
      }
  }
}
</script>
<style lang="less">
  .min-body{
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #010827;
  }
  
</style>
